import { getAllCommentsByTask } from "@/api/comments/getAllCommentsByTask"
import { useQuery } from "@tanstack/react-query"
import { useCallback } from "react";

export const useGetAllCommentsByTask = (taskId: string) => {

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['allCommentsByTask', taskId],
    queryFn: useCallback(() => getAllCommentsByTask(taskId), [taskId]),
    staleTime: 1000 * 60 * 60,  // datos considerados frescos por 1 hora
    gcTime: 1000 * 60 * 30, // datos permanecen en caché por 30 minutos
    refetchOnMount: true, // revalidar al montar el componente
    refetchOnWindowFocus: false, // no revalidar al enfocar la ventana
  })

  const comments = data?.data || [];

  return { comments, isLoading, error, refetch };
}